(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/hooks/use-team-result.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/hooks/use-team-result.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const fetchTeamResult = svs.components.marketplaceCompetition.services.actions.teamsActions.fetchTeamResult;
const patchTeamResultAction = svs.components.marketplaceCompetition.services.actions.teamsActions.patchTeamResultAction;
const selectTeamResult = svs.components.marketplaceCompetition.services.selectors.selectTeamResult;
const useTeams = svs.components.marketplaceCompetition.services.hooks.useTeams;

const useTeamResult = (competitionId, teamId) => {
  const dispatch = useDispatch();
  const _useTeams = useTeams(competitionId),
    teamsData = _useTeams.teams;
  const teamResult = useSelector(state => selectTeamResult(state, competitionId, teamId));
  useEffect(() => {
    if (teamsData && teamsData[teamId] && !teamResult.data) {
      dispatch(fetchTeamResult({
        competitionId,
        teamId
      }));
    }
  }, [teamResult, competitionId, teamId, dispatch, teamsData]);

  const useSocket = svs.components.lbUtils.socket.useSocket;
  const subscriptionUrl = "/player/2/competitions/".concat(competitionId, "/team/result?teamId=").concat(teamId);
  useSocket(subscriptionUrl, msg => {
    if (!msg) {
      return;
    }
    let parsed;
    try {
      parsed = typeof msg === 'string' ? JSON.parse(msg) : msg;
    } catch (e) {
      return;
    }
    const normalizePersonalResults = svs.components.marketplaceCompetition.services.helpers.normalizePersonalResults;
    const _normalizePersonalRes = normalizePersonalResults(parsed),
      _normalizePersonalRes2 = _slicedToArray(_normalizePersonalRes, 2),
      teamsResult = _normalizePersonalRes2[1];
    const teamData = teamsResult && teamsResult[teamId] ? teamsResult[teamId] : null;
    if (teamData) {
      dispatch(patchTeamResultAction({
        competitionId,
        teamId,
        data: teamData
      }));
    }
  }, {
    sendInitialUpdate: false,
    skip: svs.isServer || !competitionId || !teamId
  });
  return teamResult;
};
setGlobal('svs.components.marketplaceCompetition.services.hooks.useTeamResult', useTeamResult);

 })(window);